import type {
  EnvironmentProviders} from '@angular/core';
import {
  APP_INITIALIZER,
  makeEnvironmentProviders,
} from '@angular/core';

import { AppConfigService } from './app-config.service';

/**
 * Provee la carga de `/config.json` como APP_INITIALIZER.
 * Debe ir PRIMERO en la lista de providers de core: OIDC y HTTP dependen de él.
 */
export function provideAppConfig(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: APP_INITIALIZER,
      useFactory: (config: AppConfigService) => () => config.load(),
      deps: [AppConfigService],
      multi: true,
    },
  ]);
}
